export default function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-main">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-thinking-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-secondary text-sm">Loading...</p>
      </div>
    </div>
  );
}
